import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fontsBarlow.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./fonts/BarlowCondensed-SemiBold.ttf%22,%22style%22:%22normal%22,%22weight%22:%22600%22}],%22display%22:%22fallback%22,%22variable%22:%22--font-barlow%22}],%22variableName%22:%22barlowCondensedFont%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'barlowCondensedFont', 'barlowCondensedFont Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
